import React, { Component as C } from "react"
import { toJss } from "@cirrus/legacy/app-common/alt/framework/skin/skinUtils.es6"
import jss from "jss"
import { isNilOrEmpty } from "ramda-extension"

// TODO: Refactor to new SkinProvider

const withSkinV2 = (data) => {
  let { skinObjectSelector, hierarchySkinObjectSelector, defaultSkinObject } = data

  function WrapComponent(Component) {
    let dynamicStyles = null

    class ComponentWithSkin extends C {
      constructor(props) {
        super(props)

        let skinObject = isNilOrEmpty(App.skinObject) ? {} : skinObjectSelector(App.skinObject)

        let hierarchySkinTransformedObject = isNilOrEmpty(App.hierarchySkinObject)
          ? {}
          : hierarchySkinObjectSelector && hierarchySkinObjectSelector(App.hierarchySkinObject)

        if (dynamicStyles == null || App.skinChanged) {
          const dynamicStylesConfig = toJss(
            skinObject,
            defaultSkinObject,
            hierarchySkinTransformedObject,
          )

          dynamicStyles = jss.createStyleSheet(dynamicStylesConfig).attach()

          App.skinChanged = false
        }
      }

      render() {
        return <Component {...this.props} dynamicStyles={dynamicStyles} />
      }
    }

    return ComponentWithSkin
  }

  return WrapComponent
}

export default withSkinV2
